<template>
  <div class="refund_bg">
    <title-bar-back :title="'填写退货物流'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 物流单号 -->
    <div class="total_price total_price_padd top_margin clearfix">
      <van-field
        v-model="refundDet"
        label="物流单号"
        placeholder="请输入物流单号"
      />
    </div>
    <!-- 物流单号 -->
    <div class="total_price clearfix">
      <div class="bor_line bor_line_bottom">
        <van-field
          v-model="logisticsName"
          label="物流公司"
          placeholder="请输入物流公司"
        />
      </div>
    </div>
    <!-- 添加按钮 -->
    <div class="clearfix add_btn">
      <p class="add_more right" @click="addMore">添加</p>
    </div>
    <!-- 物流信息列表 -->
    <div v-if="logisticsList.length">
      <add-logistics-list
        :logistics-list="logisticsList"
        @delLogist="delLogist"
      />
    </div>
    <!-- 提交 -->
    <div class="bottom_mar" />
    <div class="submit_btn" @click="submitLog">提交</div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import AddLogisticsList from "./components/AddLogisticsList";
export default {
  name: "AddLogistics",
  components: {
    TitleBarBack,
    AddLogisticsList
  },
  data() {
    return {
      refundList: [],
      refundDet: "",
      logisticsName: "",
      logisticsList: []
    };
  },
  computed: {
    getAfterLogistics() {
      return this.$store.getters.getAfterLogistics;
    }
  },
  mounted() {
    if (this.$route.query.modify) {
      this.getData();
    }
  },
  methods: {
    // 填写物流数据
    getData() {
      this.$store
        .dispatch("order/getAfterLogistics", {
          params: {
            id: this.$route.query.id
          }
        })
        .then(() => {
          this.logisticsList = JSON.parse(
            JSON.stringify(this.getAfterLogistics)
          );
          this.logisticsList.forEach((item, index) => {
            item.title = `物流信息${index + 1}`;
          });
          // console.log(this.logisticsList, 2323232);
        })
        .catch(() => {});
    },
    // 顶部返回
    back() {
      this.$router.go(-1);
    },
    // 添加物流
    addMore() {
      if (!this.refundDet.trim() || !this.logisticsName.trim()) {
        this.$toast("请输入物流信息后添加");
        return;
      }
      this.logisticsList.push({
        title: `物流信息${this.logisticsList.length + 1}`,
        trackingNo: this.refundDet,
        logisticsName: this.logisticsName
      });
      this.refundDet = "";
      this.logisticsName = "";
    },
    // 删除物流列表数据
    delLogist(index) {
      this.logisticsList.splice(index, 1);
    },
    // 提交物流信息
    submitLog() {
      this.logisticsList.forEach(item => {
        delete item.title;
      });
      this.$store
        .dispatch("order/commitLogistics", {
          params: {
            id: this.$route.query.id,
            logisticsList: this.logisticsList
          }
        })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.total_price {
  padding: 0 15px;
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 20px;
}
.total_price_padd {
  padding: 15px 15px;
}
.total_price >>> .van-cell {
  color: #222;
  padding: 0;
}
.bor_line {
  padding: 15px 0;
}
.bor_line_bottom {
  border-top: 1px solid #eee;
}
.com_det {
  display: inline-block;
  width: 90px;
}
/* 添加按钮 */
.add_btn {
  margin: 10px 15px 20px;
}
.add_more {
  font-size: 14px;
  font-weight: 400;
  color: rgba(221, 145, 50, 1);
  line-height: 30px;
  padding: 0 25px;
  border-radius: 15px;
  border: 1px solid rgba(221, 145, 50, 1);
}
.bottom_mar {
  height: 70px;
}
.submit_btn {
  position: fixed;
  bottom: 5px;
  left: 0;
  right: 0;
  margin: 15px;
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 20px;
  font-size: 15px;
  font-weight: 400;
  color: #fff;
  line-height: 40px;
  text-align: center;
}
</style>
